module.exports = __webpack_public_path__ + "built-card-bottom-left.1UG0k2ks.png";